/* Creatine quiz. Copy and profile rules live in this file. The Liquid snippet
   only supplies the product, illustrations, icons, and theme-editor overrides.
   Inline and popup share one session, so starting in the article suppresses
   the popup. */
(() => {
  if (window.__tdlCreatineQuizBooted) return;
  window.__tdlCreatineQuizBooted = true;

  const inlineSlot = document.querySelector('[data-tdl-quiz-slot]');
  if (!document.querySelector('[data-tdl-quiz]')) return;

  const config = {};
  document.querySelectorAll('[data-tdl-quiz-config]').forEach((node) => {
    let data = {};
    try {
      data = JSON.parse(node.textContent);
    } catch (error) {
      return;
    }
    Object.keys(data).forEach((key) => {
      if (key === 'icons') config.icons = Object.assign(config.icons || {}, data.icons || {});
      else if (data[key]) config[key] = data[key];
    });
  });
  const ICON = config.icons || {};
  const KEY_DISMISS = 'tdl_creatine_quiz_dismissed_at';
  const KEY_DONE = 'tdl_creatine_quiz_completed_at';
  const KEY_SESSION = 'tdl_creatine_quiz_session';
  const DAY = 86400000;
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new Set();
  let frame = 0;
  let advanceTimer = 0;
  let active = null;
  let lockedScroll = 0;

  const QUESTIONS = [
    {
      id: 'age_range',
      title: 'How old are you?',
      sub: 'Creatine can play a different role at different stages of life.',
      options: [
        { value: 'under_40', label: 'Under 40', icon: 'sparkles' },
        { value: '40_49', label: '40-49', icon: 'sun' },
        { value: '50_59', label: '50-59', icon: 'sunrise' },
        { value: '60_69', label: '60-69', icon: 'heart' },
        { value: '70_plus', label: '70+', icon: 'leaf' },
      ],
    },
    {
      id: 'creatine_goal',
      title: "What's your biggest reason for taking creatine?",
      options: [
        { value: 'maintain_muscle', label: 'Maintain muscle mass', icon: 'shield-check' },
        { value: 'build_strength', label: 'Build more strength', icon: 'trophy' },
        { value: 'workout_performance', label: 'Improve workout performance', icon: 'zap' },
        { value: 'stay_active', label: 'Stay strong & active as I age', icon: 'heart-pulse' },
        { value: 'preserve_muscle', label: 'Preserve muscle while losing weight', icon: 'scale' },
        { value: 'cognitive', label: 'Support cognitive function & mental sharpness', icon: 'brain' },
        { value: 'healthy_aging', label: 'Support healthy aging overall', icon: 'leaf' },
      ],
    },
    {
      id: 'activity_level',
      title: 'How active are you right now?',
      sub: 'Your activity level helps us personalize your creatine routine.',
      options: [
        { value: 'sedentary', label: 'Mostly sedentary', icon: 'bed' },
        { value: 'walking', label: 'Walking / light activity', icon: 'footprints' },
        { value: '1_2', label: 'Exercise 1-2x per week', icon: 'gauge' },
        { value: '3_4', label: 'Exercise 3-4x per week', icon: 'trending-up' },
        { value: '5_plus', label: 'Train 5+x per week', icon: 'trophy' },
      ],
    },
    {
      id: 'creatine_experience',
      title: 'Where are you in your creatine journey?',
      options: [
        { value: 'new', label: "I'm completely new to creatine", icon: 'sparkles' },
        { value: 'researched', label: "I've researched it but haven't started", icon: 'book-open' },
        { value: 'used_before', label: "I've used creatine before", icon: 'refresh-cw' },
        { value: 'already', label: 'I already take creatine', icon: 'check' },
      ],
    },
  ];

  const GOAL_PROFILE = {
    maintain_muscle: 'muscle_strength',
    build_strength: 'muscle_strength',
    workout_performance: 'sports_performance',
    stay_active: 'active_aging',
    healthy_aging: 'active_aging',
    preserve_muscle: 'muscle_preservation',
    cognitive: 'cognitive_function',
  };

  const PROFILES = {
    muscle_strength: {
      label: 'Muscle & Strength',
      headline: 'Muscle & Strength',
      body: 'Based on your answers, maintaining or building muscle and strength is your biggest priority. Creatine is one of the most extensively studied sports nutrition ingredients and is widely used to support strength and high-intensity exercise performance.',
      focus: ['Resistance training', 'Adequate protein', 'Daily creatine consistency'],
      dose: '5 g Creatine Monohydrate Daily',
      bridge: 'Daily Labs makes that simple: 4 Gummies = 5 g Creatine Monohydrate. No scoops. No mixing. No guesswork.',
      cta: 'Get My Daily Creatine',
    },
    sports_performance: {
      label: 'Sports Performance',
      headline: 'Training Performance',
      body: "You're focused on getting more from your training. Creatine is commonly used to support strength and repeated high-intensity exercise performance.",
      focus: ['Train consistently', 'Recover properly', 'Get enough protein', 'Take creatine consistently'],
      dose: '5 g every day.',
      bridge: 'Daily Labs: 4 Gummies = 5 g Creatine Monohydrate',
      cta: 'Upgrade My Daily Routine',
    },
    active_aging: {
      label: 'Active Aging',
      headline: 'Staying Strong & Active',
      body: "Your goal isn't simply performing better today - it's maintaining strength, muscle and an active lifestyle over time. Creatine can complement a routine built around resistance exercise, adequate protein and regular physical activity.",
      focus: ['Maintain muscle', 'Keep building strength', 'Stay active', 'Make consistency easy'],
      bridge: 'Daily Labs provides: 5 g Creatine Monohydrate in 4 gummies.',
      cta: 'Support My Daily Strength',
    },
    muscle_preservation: {
      label: 'Muscle Preservation',
      headline: 'Muscle Preservation',
      body: 'Losing weight is only part of the goal. Maintaining muscle matters too. Creatine is not a fat burner. Instead, it can complement a weight-management routine built around resistance training, adequate protein and maintaining physical performance.',
      focus: ['Adequate protein', 'Resistance training', 'Sustainable nutrition', 'Muscle-focused habits'],
      cta: 'Support My Muscle Routine',
    },
    cognitive_function: {
      label: 'Cognitive Function',
      headline: 'Cognitive Function',
      body: 'Creatine is about more than the gym. Creatine plays a role in cellular energy metabolism, including in the brain, and research continues to explore its role in cognitive function.',
      focus: ['Good sleep', 'Regular physical activity', 'Balanced nutrition', 'Daily consistency'],
      cta: 'Add Creatine to My Routine',
    },
  };

  const AGE_COPY = {
    under_40: 'Building strong habits now can support your training and long-term physical performance.',
    '40_49': 'Consistency in training, nutrition and daily habits becomes increasingly valuable as your goals evolve over time.',
    '50_59': 'Maintaining muscle and strength becomes increasingly relevant through midlife, making resistance training and consistent nutrition especially valuable.',
    '60_69': 'Your focus increasingly shifts toward maintaining strength, physical capability and an active lifestyle.',
    '70_plus': 'Maintaining physical strength, regular movement and an active routine can become increasingly important with age.',
  };

  const ACTIVITY_COPY = {
    sedentary: "Since structured exercise isn't currently a major part of your routine, introducing appropriate resistance exercise may be more valuable than relying on any supplement alone.",
    walking: 'You already have a useful movement foundation. Adding resistance-focused activity can complement your existing routine.',
    '1_2': 'You already have a useful activity foundation. Building consistency is the next priority.',
    '3_4': 'You already have a strong activity base. Consistency in training, nutrition and recovery becomes especially important.',
    '5_plus': 'With a high training frequency, recovery, nutrition and daily consistency become especially important.',
  };

  const EXPERIENCE_COPY = {
    new: "You're new to creatine, so there's no need to overcomplicate it. Start with the basics and focus on consistency.",
    researched: 'You already understand some of the basics. The next step is building a simple routine you can maintain consistently.',
    used_before: "Since you've used creatine before, your biggest opportunity may simply be making daily use more consistent and convenient.",
    already: "You're already using creatine, so the main focus is maintaining a consistent daily routine that fits your lifestyle.",
  };

  const BENEFITS = [
    'Your #1 Creatine Benefit',
    'Your Personalized Creatine Routine',
    'How Much to Take',
    'How to Stay Consistent',
    'Tips Based on Your Goals',
  ];

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, (ch) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[ch]));
  }

  function icon(name) {
    return ICON[name] || '';
  }

  function readStore(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStore(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      /* Private mode. The quiz still runs for this view. */
    }
  }

  function readSession() {
    const raw = readStore(window.sessionStorage, KEY_SESSION);
    if (!raw) return { started: false, step: 'intro', index: 0, answers: {} };
    try {
      const data = JSON.parse(raw);
      data.answers = data.answers || {};
      return data;
    } catch (error) {
      return { started: false, step: 'intro', index: 0, answers: {} };
    }
  }

  let session = readSession();

  function saveSession() {
    writeStore(window.sessionStorage, KEY_SESSION, JSON.stringify(session));
  }

  function popupRoot() {
    return document.querySelector('[data-tdl-quiz][data-mode="popup"]');
  }

  function inlineRoot() {
    return document.querySelector('[data-tdl-quiz][data-mode="inline"]');
  }

  function caps() {
    const root = popupRoot();
    return {
      dismiss: Number((root && root.dataset.dismissDays) || 3),
      complete: Number((root && root.dataset.completeDays) || 30),
    };
  }

  function ageOf(key) {
    const stamp = Number(readStore(window.localStorage, key) || 0);
    return stamp ? Date.now() - stamp : Infinity;
  }

  function completedRecently() {
    return ageOf(KEY_DONE) < caps().complete * DAY;
  }

  function dismissedRecently() {
    return ageOf(KEY_DISMISS) < caps().dismiss * DAY;
  }

  function forced() {
    return new URLSearchParams(window.location.search).has('quiz');
  }

  function utm() {
    const params = new URLSearchParams(window.location.search);
    const out = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((key) => {
      out[key] = params.get(key) || '';
    });
    return out;
  }

  const attribution = utm();

  function optionLabel(questionId, value) {
    const question = QUESTIONS.find((item) => item.id === questionId);
    const option = question && question.options.find((item) => item.value === value);
    return option ? option.label : '';
  }

  function profile() {
    const id = GOAL_PROFILE[session.answers.creatine_goal] || 'muscle_strength';
    return Object.assign({ id: id }, PROFILES[id]);
  }

  function track(eventName, payload, dedupe) {
    if (dedupe) {
      if (seen.has(dedupe)) return;
      seen.add(dedupe);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
  }

  function profilePayload() {
    return {
      age_range: optionLabel('age_range', session.answers.age_range),
      creatine_goal: optionLabel('creatine_goal', session.answers.creatine_goal),
      activity_level: optionLabel('activity_level', session.answers.activity_level),
      creatine_experience: optionLabel('creatine_experience', session.answers.creatine_experience),
      creatine_profile: profile().id,
    };
  }

  function placeInline() {
    const quiz = inlineRoot();
    if (!inlineSlot || !quiz) return;
    const position = inlineSlot.getAttribute('data-tdl-quiz-position') || 'mid';
    const body = document.querySelector('.kv4-article__body');
    inlineSlot.hidden = false;
    if (position === 'end' || !body) return;
    Array.prototype.forEach.call(inlineSlot.querySelectorAll('link, script'), (node) => {
      document.body.appendChild(node);
    });
    const blocks = Array.prototype.filter.call(body.children, (el) => el !== inlineSlot && el !== quiz);
    if (!blocks.length) {
      body.appendChild(quiz);
    } else {
      const at = Math.max(0, Math.ceil(blocks.length * 0.35) - 1);
      blocks[at].after(quiz);
    }
    inlineSlot.remove();
  }

  function parts(root) {
    return {
      root: root,
      stage: root.querySelector('[data-tdl-stage]'),
      back: root.querySelector('[data-tdl-back]'),
      close: root.querySelector('[data-tdl-close]'),
      count: root.querySelector('[data-tdl-count]'),
      pips: root.querySelector('[data-tdl-pips]'),
      gate: root.querySelector('[data-tdl-gate]'),
      bar: root.querySelector('.tdl-quiz__bar'),
    };
  }

  function setMeter(ui, on, index) {
    if (ui.count) ui.count.hidden = !on;
    if (ui.pips) ui.pips.hidden = !on;
    if (!on || !ui.pips) return;
    ui.count.textContent = index + 1 + ' of ' + QUESTIONS.length;
    ui.pips.innerHTML = QUESTIONS.map((_, i) => {
      return '<span class="tdl-quiz__pip' + (i <= index ? ' is-on' : '') + '"></span>';
    }).join('');
  }

  function copyFor(root) {
    const popup = root.dataset.mode === 'popup';
    const ownTitle = root.dataset.introTitle || '';
    const ownSub = root.dataset.introSub || '';
    const ownBody = root.dataset.introBody || '';
    return {
      title: ownTitle
        ? esc(ownTitle)
        : (popup ? "What's Your <em>#1 Reason</em> to Take Creatine?" : 'Find Your <em>#1 Reason</em> to Take Creatine'),
      sub: ownSub
        ? esc(ownSub)
        : (popup ? '' : 'Strength. Muscle. Performance. Active aging. Cognitive function.'),
      body: ownBody
        ? esc(ownBody)
        : (popup
          ? 'Take the 60-second quiz to discover the creatine benefits most relevant to your goals.'
          : 'Answer 4 quick questions to discover which creatine benefits are most relevant to your goals and lifestyle.'),
      start: root.dataset.startLabel || 'Find My #1 Benefit',
    };
  }

  function renderIntro(ui) {
    const copy = copyFor(ui.root);
    setMeter(ui, false);
    if (ui.bar) ui.bar.hidden = ui.root.dataset.mode !== 'popup';
    ui.stage.innerHTML =
      '<div class="tdl-quiz__screen tdl-quiz__screen--center">' +
      '<figure class="tdl-quiz__hero"><img src="' + esc(config.introImage) + '" alt=""></figure>' +
      '<p class="tdl-quiz__eyebrow">60 seconds</p>' +
      '<h2 class="tdl-quiz__title" tabindex="-1">' + copy.title + '</h2>' +
      (copy.sub ? '<p class="tdl-quiz__sub">' + copy.sub + '</p>' : '') +
      '<p class="tdl-quiz__body">' + copy.body + '</p>' +
      '<p class="tdl-quiz__note">Takes about 60 seconds.</p>' +
      '<div class="tdl-quiz__actions"><button type="button" class="kv-btn tdl-quiz__cta" data-tdl-start>' + esc(copy.start) + '</button></div>' +
      '</div>';
  }

  function renderQuestion(ui) {
    const question = QUESTIONS[session.index];
    const selected = session.answers[question.id];
    setMeter(ui, true, session.index);
    if (ui.bar) ui.bar.hidden = false;
    const options = question.options.map((option, i) => {
      const on = selected === option.value;
      return (
        '<button type="button" class="tdl-quiz__opt' + (on ? ' is-on' : '') + '" data-tdl-opt="' + esc(option.value) + '" style="--i:' + i + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="tdl-quiz__opt-icon">' + icon(option.icon) + '</span>' +
        '<span class="tdl-quiz__opt-label">' + esc(option.label) + '</span>' +
        '<span class="tdl-quiz__tick">' + icon('check') + '</span>' +
        '</button>'
      );
    }).join('');
    ui.stage.innerHTML =
      '<div class="tdl-quiz__screen">' +
      '<h2 class="tdl-quiz__title" tabindex="-1">' + esc(question.title) + '</h2>' +
      (question.sub ? '<p class="tdl-quiz__sub">' + esc(question.sub) + '</p>' : '') +
      '<div class="tdl-quiz__options" role="radiogroup" aria-label="' + esc(question.title) + '">' + options + '</div>' +
      '</div>';
  }

  function renderAnalyze(ui) {
    setMeter(ui, false);
    if (ui.bar) ui.bar.hidden = ui.root.dataset.mode !== 'popup';
    ui.stage.innerHTML =
      '<div class="tdl-quiz__screen tdl-quiz__screen--center">' +
      '<figure class="tdl-quiz__hero"><img src="' + esc(config.walkImage) + '" alt=""></figure>' +
      '<h2 class="tdl-quiz__title" tabindex="-1">Analyzing your answers...</h2>' +
      '<div class="tdl-quiz__gauge" aria-hidden="true"><span data-tdl-bar></span></div>' +
      '</div>';
    const bar = ui.stage.querySelector('[data-tdl-bar]');
    const span = calm.matches ? 200 : 1000;
    const started = performance.now();
    const tick = (now) => {
      const ratio = Math.min(1, (now - started) / span);
      if (bar) bar.style.transform = 'scaleX(' + ratio + ')';
      if (ratio < 1 && session.step === 'analyze') {
        frame = window.requestAnimationFrame(tick);
        return;
      }
      if (session.step !== 'analyze') return;
      session.step = 'gate';
      saveSession();
      render();
    };
    frame = window.requestAnimationFrame(tick);
  }

  function renderGate(ui) {
    setMeter(ui, false);
    if (ui.bar) ui.bar.hidden = false;
    const checks = BENEFITS.map((item) => {
      return '<li class="tdl-quiz__check"><span class="tdl-quiz__check-box">' + icon('check') + '</span><span>' + esc(item) + '</span></li>';
    }).join('');
    ui.stage.innerHTML =
      '<div class="tdl-quiz__screen tdl-quiz__screen--center">' +
      '<span class="tdl-quiz__seal">' + icon('mail') + '</span>' +
      '<h2 class="tdl-quiz__title" tabindex="-1">Your Personalized Creatine Profile Is Ready</h2>' +
      '<p class="tdl-quiz__body">We\'ve matched your goals, age and activity level to the creatine benefits most relevant to you.</p>' +
      '<ul class="tdl-quiz__checks">' + checks + '</ul>' +
      '<div data-tdl-gate-slot></div>' +
      '</div>';
    const slot = ui.stage.querySelector('[data-tdl-gate-slot]');
    if (slot && ui.gate) slot.appendChild(ui.gate.content.cloneNode(true));
    const form = ui.stage.querySelector('form');
    if (form) form.noValidate = true;
    const tags = ui.stage.querySelector('[data-tdl-tags]');
    if (tags) tags.value = leadTags();
    track('quiz_email_view', profilePayload(), 'quiz_email_view');
  }

  function renderResult(ui) {
    const item = profile();
    const facts = [
      ['Age', optionLabel('age_range', session.answers.age_range)],
      ['Activity', optionLabel('activity_level', session.answers.activity_level)],
      ['Creatine experience', optionLabel('creatine_experience', session.answers.creatine_experience)],
      ['Primary focus', optionLabel('creatine_goal', session.answers.creatine_goal)],
    ];
    setMeter(ui, false);
    if (ui.bar) ui.bar.hidden = ui.root.dataset.mode !== 'popup';
    const shop = config.shopLabel || 'Shop Creatine Daily Gummies';
    ui.stage.innerHTML =
      '<div class="tdl-quiz__screen">' +
      '<p class="tdl-quiz__eyebrow">' + esc(item.label) + '</p>' +
      '<h2 class="tdl-quiz__title" tabindex="-1">Your #1 Creatine Focus: <em>' + esc(item.headline) + '</em></h2>' +
      '<p class="tdl-quiz__body">' + esc(item.body) + '</p>' +
      '<ul class="tdl-quiz__facts">' + facts.map((row) => '<li><span>' + esc(row[0]) + '</span><strong>' + esc(row[1]) + '</strong></li>').join('') + '</ul>' +
      '<p class="tdl-quiz__body">' + esc(AGE_COPY[session.answers.age_range] || '') + '</p>' +
      '<p class="tdl-quiz__body">' + esc(ACTIVITY_COPY[session.answers.activity_level] || '') + '</p>' +
      '<p class="tdl-quiz__body">' + esc(EXPERIENCE_COPY[session.answers.creatine_experience] || '') + '</p>' +
      '<p class="tdl-quiz__kicker">Your focus</p>' +
      '<ul class="tdl-quiz__focus">' + item.focus.map((line) => '<li>' + esc(line) + '</li>').join('') + '</ul>' +
      (item.dose ? '<p class="tdl-quiz__dose">' + esc(item.dose) + '</p>' : '') +
      (item.bridge ? '<p class="tdl-quiz__body">' + esc(item.bridge) + '</p>' : '') +
      '<div class="tdl-quiz__actions"><a class="kv-btn tdl-quiz__cta" data-tdl-product href="' + esc(config.productUrl) + '">' + esc(item.cta) + '</a></div>' +
      '<div class="tdl-quiz__offer">' +
      '<figure class="tdl-quiz__pack"><img src="' + esc(config.productImage) + '" alt="' + esc(config.productTitle) + '"></figure>' +
      '<h2 class="tdl-quiz__title">Make Creatine One Less Thing to Think About</h2>' +
      '<p class="tdl-quiz__body">No powder. No scoops. No mixing.</p>' +
      '<p class="tdl-quiz__dose">4 gummies = 5 g Creatine Monohydrate.</p>' +
      '<div class="tdl-quiz__actions"><a class="kv-btn tdl-quiz__cta" data-tdl-product href="' + esc(config.productUrl) + '">' + esc(shop) + '</a></div>' +
      '<p class="tdl-quiz__later">Not ready yet? We\'ve sent your Creatine Profile and guide to your email so you can come back whenever you\'re ready.</p>' +
      '</div></div>';
    track('quiz_result_view', profilePayload(), 'quiz_result_view');
  }

  function render() {
    if (!active) return;
    window.cancelAnimationFrame(frame);
    const ui = parts(active);
    if (ui.back) ui.back.hidden = !(session.step === 'question' || session.step === 'gate');
    if (session.step === 'intro') renderIntro(ui);
    else if (session.step === 'question') renderQuestion(ui);
    else if (session.step === 'analyze') renderAnalyze(ui);
    else if (session.step === 'gate') renderGate(ui);
    else if (session.step === 'result') renderResult(ui);
    const sheet = active.querySelector('[data-tdl-sheet]');
    const label = sheet && sheet.getAttribute('aria-labelledby');
    const title = ui.stage && ui.stage.querySelector('.tdl-quiz__title');
    if (label && title) title.id = label;
    if (session.step !== 'intro' && title) title.focus({ preventScroll: true });
  }

  function show(root) {
    active = root;
    render();
  }

  function start() {
    session.started = true;
    session.step = 'question';
    session.index = 0;
    saveSession();
    track('quiz_start', { quiz: 'creatine' }, 'quiz_start');
    render();
  }

  function choose(value) {
    const question = QUESTIONS[session.index];
    if (!question || session.step !== 'question') return;
    session.answers[question.id] = value;
    session.started = true;
    saveSession();
    track('quiz_question_answered', {
      question_number: session.index + 1,
      question: question.title,
      answer: optionLabel(question.id, value),
    }, 'q:' + question.id + ':' + value);
    const buttons = active.querySelectorAll('[data-tdl-opt]');
    Array.prototype.forEach.call(buttons, (button) => {
      const on = button.getAttribute('data-tdl-opt') === value;
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    window.clearTimeout(advanceTimer);
    advanceTimer = window.setTimeout(() => {
      if (session.index < QUESTIONS.length - 1) {
        session.index += 1;
        session.step = 'question';
      } else {
        session.step = 'analyze';
      }
      saveSession();
      render();
    }, calm.matches ? 0 : 200);
  }

  function back() {
    window.clearTimeout(advanceTimer);
    window.cancelAnimationFrame(frame);
    if (session.step === 'gate' || session.step === 'analyze') {
      session.step = 'question';
      session.index = QUESTIONS.length - 1;
    } else if (session.step === 'question' && session.index > 0) {
      session.index -= 1;
    } else if (session.step === 'question') {
      session.step = 'intro';
      session.started = false;
    }
    saveSession();
    render();
  }

  function leadTags() {
    const tags = ['creatine-quiz', 'newsletter', 'quiz-profile-' + profile().id.replace(/_/g, '-')];
    Object.keys(session.answers).forEach((key) => {
      if (session.answers[key]) tags.push('quiz-' + key.replace(/_/g, '-') + '-' + String(session.answers[key]).replace(/_/g, '-'));
    });
    return tags.join(',');
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function submitEmail(form) {
    if (form.dataset.tdlSending === '1') return;
    const field = form.querySelector('input[type="email"]');
    const error = form.querySelector('[data-tdl-error]');
    const email = field ? field.value.trim() : '';
    if (!validEmail(email)) {
      if (error) {
        error.hidden = false;
        error.textContent = 'Enter a valid email address.';
      }
      if (field) field.focus();
      return;
    }
    if (error) error.hidden = true;
    form.dataset.tdlSending = '1';
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    const props = Object.assign({
      $email: email,
      landing_url: window.location.href,
      referrer: document.referrer || '',
    }, profilePayload(), attribution);
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', props]);
      window.klaviyo.push(['track', 'Creatine Quiz Lead', props]);
    } catch (error) {
      /* Consent tooling may block the queue. The result still opens. */
    }

    const tags = form.querySelector('[data-tdl-tags]');
    if (tags) tags.value = leadTags();
    /* A background fetch is dropped by Shopify's form protection, so the
       customer record is never created. A real submit into a hidden frame is
       the same POST the newsletter uses, and the quiz page stays put. */
    let frame = document.getElementById('tdl-quiz-customer-frame');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.id = 'tdl-quiz-customer-frame';
      frame.name = 'tdl-quiz-customer-frame';
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      document.body.appendChild(frame);
    }
    form.setAttribute('target', frame.name);

    writeStore(window.localStorage, KEY_DONE, String(Date.now()));
    session.step = 'result';
    session.completed = true;
    saveSession();
    track('quiz_lead', profilePayload(), 'quiz_lead');
    window.setTimeout(() => {
      if (form.isConnected) document.body.appendChild(form);
      render();
    }, 0);
  }

  function onClick(event) {
    const root = event.currentTarget;
    if (event.target.closest('[data-tdl-start]')) {
      active = root;
      start();
      return;
    }
    if (event.target.closest('[data-tdl-back]')) {
      active = root;
      back();
      return;
    }
    const option = event.target.closest('[data-tdl-opt]');
    if (option && root.contains(option)) {
      active = root;
      choose(option.getAttribute('data-tdl-opt'));
      return;
    }
    const product = event.target.closest('[data-tdl-product]');
    if (product) {
      track('quiz_product_click', {
        creatine_profile: profile().id,
        cta_text: product.textContent.replace(/\s+/g, ' ').trim(),
        destination: product.getAttribute('href') || '',
      });
    }
  }

  function onSubmit(event) {
    const form = event.target.closest('form');
    if (!form || !event.currentTarget.contains(form)) return;
    const field = form.querySelector('input[type="email"]');
    const email = field ? field.value.trim() : '';
    if (!validEmail(email) || form.dataset.tdlSending === '1') {
      event.preventDefault();
    }
    active = event.currentTarget;
    submitEmail(form);
  }

  function bind(root) {
    root.addEventListener('click', onClick);
    root.addEventListener('submit', onSubmit);
  }

  function lockPage() {
    lockedScroll = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + lockedScroll + 'px';
    document.documentElement.classList.add('tdl-quiz-lock');
  }

  function unlockPage() {
    document.documentElement.classList.remove('tdl-quiz-lock');
    document.body.style.top = '';
    window.scrollTo(0, lockedScroll);
  }

  function trap(event) {
    const root = popupRoot();
    if (!root || root.hidden || event.key !== 'Tab') return;
    const nodes = root.querySelectorAll('button, a, input, [tabindex]:not([tabindex="-1"])');
    const items = Array.prototype.filter.call(nodes, (el) => !el.disabled && el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openPopup() {
    const root = popupRoot();
    if (!root || !root.hidden) return;
    if (root.parentElement !== document.body) document.body.appendChild(root);
    root.hidden = false;
    lockPage();
    show(root);
    track('quiz_view', { quiz: 'creatine' }, 'quiz_view');
    const focus = root.querySelector('[data-tdl-close]') || root.querySelector('.tdl-quiz__title');
    if (focus) focus.focus();
  }

  function closePopup() {
    const root = popupRoot();
    if (!root || root.hidden) return;
    root.hidden = true;
    unlockPage();
    if (!session.completed) writeStore(window.localStorage, KEY_DISMISS, String(Date.now()));
    const inline = inlineRoot();
    if (inline && !completedRecently()) {
      if (!session.started) session.step = 'intro';
      show(inline);
    }
  }

  function armPopup() {
    const root = popupRoot();
    if (!root) return;
    const delay = Number(root.dataset.desktopDelay || 5) * 1000;
    let armed = true;

    const eligible = () => {
      if (!armed || !root.hidden) return false;
      if (session.started && !forced()) return false;
      if (!forced() && (completedRecently() || dismissedRecently())) return false;
      return true;
    };

    const tryOpen = () => {
      if (!eligible()) return;
      armed = false;
      openPopup();
    };

    if (forced()) {
      tryOpen();
      return;
    }

    window.setTimeout(tryOpen, delay);

    /* Any exit of the page, including before the timer. mouseleave covers the
       whole viewport; mouseout catches the cursor crossing into the browser chrome. */
    const onLeave = (event) => {
      const next = event.relatedTarget || event.toElement;
      if (next && next.nodeName !== 'HTML') return;
      const leftViewport = event.clientY <= 0 || event.clientX <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight;
      if (event.type === 'mouseout' && !leftViewport) return;
      tryOpen();
    };
    document.addEventListener('mouseout', onLeave);
    document.documentElement.addEventListener('mouseleave', onLeave);

    /* Phones have no cursor leave. Coming back to the top after reading
       is the same "I'm leaving" signal. */
    let lastY = window.scrollY;
    let deepest = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > deepest) deepest = y;
      if (deepest > 240 && y < 24 && y < lastY) tryOpen();
      lastY = y;
    }, { passive: true });

    const close = root.querySelector('[data-tdl-close]');
    if (close) close.addEventListener('click', closePopup);
    const backdrop = root.querySelector('[data-tdl-backdrop]');
    if (backdrop) backdrop.addEventListener('click', closePopup);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root && !root.hidden) {
        event.preventDefault();
        closePopup();
        return;
      }
      trap(event);
    });
  }

  function bootInline() {
    const root = inlineRoot();
    if (!root) return;
    if (completedRecently() && !forced()) {
      root.remove();
      return;
    }
    bind(root);
    if (session.started) show(root);
    else show(root);
  }

  placeInline();
  const popup = popupRoot();
  if (popup) bind(popup);
  bootInline();
  armPopup();

  if (inlineRoot() && !session.started) {
    const card = inlineRoot();
    if ('IntersectionObserver' in window) {
      const watch = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        track('quiz_view', { quiz: 'creatine' }, 'quiz_view');
        watch.disconnect();
      }, { threshold: 0.4 });
      watch.observe(card);
    }
  }
})();
